export var TargetTemplateInclude = {
    aims: true,
};
//# sourceMappingURL=TargetTemplate.js.map